function getUrl() {
    return `https://${window.BC_API_ENDPOINTS_CONF.sso}/sso-server/ws/mail/reset`;
}

function getConfirmUrl() {
    return `https://${window.BC_API_ENDPOINTS_CONF.sso}/sso-server/ws/mail/reset/confirm`;
}

export function getEmailFromConfirmCode(confirmCode) {
    return fetch(`${getUrl()}?code=${confirmCode}`).then((response) => {
        if (response.status === 200) {
            return response.json();
        }

        return Promise.reject(response);
    });
}

export function postNewMail(confirmCode, password, newMail) {
    const formData = new URLSearchParams();
    formData.append('password', password);
    formData.append('newMail', newMail);

    return fetch(`${getUrl()}?code=${confirmCode}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
    }).then((response) => {
        if (response.ok) {
            return response;
        }

        return Promise.reject(response);
    });
}

export function confirmNewMail(finishCode) {
    return fetch(`${getConfirmUrl()}?code=${finishCode}`, {
        method: 'POST',
    }).then((response) => {
        if (response.ok) {
            return response;
        }

        return Promise.reject(response);
    });
}
